import { AxiosStatic } from "axios";
import { toCamel, toSnake } from "snake-camel";

export interface VehicleType {
  id: number;
  name: string;
}

export interface VehicleOption {
  id: number;
  name: string;
  vehicleTypeId: number | null;
}

/**
 * The vehicle a fitment is for. Its kind decides which categories and makes are
 * offered, so both are asked for by type rather than filtered in the browser.
 */
export default ($axios: AxiosStatic) => ({
  async list(): Promise<VehicleType[]> {
    const response = (await $axios.get("/api/vehicle-types")).data.data;
    return response.map((row: any) => toCamel(row) as VehicleType);
  },

  async categories(vehicleTypeId?: number | null): Promise<VehicleOption[]> {
    const response = (
      await $axios.get("/api/vehicle-types/categories", {
        params: toSnake({ vehicleTypeId: vehicleTypeId || undefined })
      })
    ).data.data;
    return response.map((row: any) => toCamel(row) as VehicleOption);
  },

  async makes(vehicleTypeId?: number | null): Promise<VehicleOption[]> {
    const response = (
      await $axios.get("/api/vehicle-types/makes", {
        params: toSnake({ vehicleTypeId: vehicleTypeId || undefined })
      })
    ).data.data;
    return response.map((row: any) => toCamel(row) as VehicleOption);
  }
});
